import { Grid, Stack, Button } from "@mui/material";
import History from "./components/History";
import ParamsManager from "./components/ParamsManager";
import SelectImageModel from "./components/SelectImageModel";

import { useTranslation } from "react-i18next";
import Meta from "../../../components/common/Meta";
import { uiHeight } from "../../../utils/uiHeight";
import QuickSelection from "./components/QuickSelection";
import { useChatNavigate } from "../../../hooks/useChatNavigate";
import { ChatBubble } from "@mui/icons-material";
import { RowBox } from "../../../utils/styledBox";
import { BiSolidCrown } from "react-icons/bi";
import { Typography } from "@mui/material";
// import { GradientTypography } from "../../../utils/gradientTypography";
// import ImageIcon from "@mui/icons-material/Image";

const ImageGenerator = () => {
  const { t } = useTranslation();
  const { navigateToChat } = useChatNavigate();

  return (
    <>
      <Meta
        title={t("juno.goToGenerator")}
        meta={[{ name: "robots", content: "noindex, nofollow" }]}
        route={"Studio JUNO by Tenak AI"}
      />
      <Grid
        container
        spacing={1}
        justifyContent="center"
        sx={{ height: { xs: "100%", sm: `calc(${uiHeight()} - 100px)` }, px: { xs: 0, md: 2 } }}
      >
        {/* Chat */}
        <Grid
          sx={{ alignItems: "center", display: "flex", gap: 4, height: 35, flexDirection: { xs: "column", sm: "row" } }}
          size={{ xs: 12 }}
        >
          {/* <RowBox sx={{ alignItems: "center", width: "auto" }}>
            <ImageIcon sx={{ mr: 1, color: "white" }} />
            <GradientTypography variant={"h5"} component={"h1"} sx={{ whiteSpace: "nowrap" }}>
              Image Generator
            </GradientTypography>
          </RowBox> */}
          <RowBox alignItems={"flex-start"} sx={{ width: "auto" }}>
            <Button
              variant="text"
              onClick={() => navigateToChat()}
              startIcon={<ChatBubble fontSize="small" sx={{ color: "secondary.main" }} />}
              endIcon={
                <RowBox>
                  <BiSolidCrown style={{ fontSize: 12, marginRight: 2, color: "#c29e00" }} />
                  <Typography sx={{ fontSize: "12px!important;", color: "#c29e00", fontWeight: "bold" }}>
                    VIP
                  </Typography>
                </RowBox>
              }
              size="small"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              disableElevation
            >
              {t("juno.goToChat")}
            </Button>
          </RowBox>
          <RowBox sx={{ overflow: "auto" }}>
            <QuickSelection />
          </RowBox>
        </Grid>

        {/* Menu */}
        <Grid
          sx={{ height: "100%" }}
          size={{
            xs: 12,
            md: 2.5,
          }}
        >
          <Stack spacing={1} sx={{ height: "100%" }}>
            <SelectImageModel />
            <ParamsManager />
          </Stack>
        </Grid>

        {/* Main */}
        <Grid
          sx={{ height: "100%" }}
          size={{
            xs: 12,
            md: 9.5,
          }}
        >
          <History />
        </Grid>
      </Grid>
    </>
  );
};
export default ImageGenerator;
